// https://vike.dev/lang
import type { PageContext } from "vike/types";

import { DEFAULT_LANGUAGE, HREFLANG_BY_LOCALE, Locale } from "@mixins/locales/constants";

/**
 * `<html lang>` for the page.
 *
 * vike-react defaults this to `"en"`, which mislabelled every Armenian page as
 * English. The value must be a BCP 47 tag; it is read through
 * `HREFLANG_BY_LOCALE` rather than from the URL segment, so the two can never
 * drift apart again (they did when Armenian sat under `/am/`, i.e. Amharic).
 *
 * Lives in its own `+lang.ts` because Vike forbids function values inside
 * `+config.ts` (https://vike.dev/error/runtime-in-config).
 */
export default function lang(pageContext: PageContext): string {
	const locale = (pageContext.locale as Locale | undefined) ?? DEFAULT_LANGUAGE;
	return HREFLANG_BY_LOCALE[locale] ?? HREFLANG_BY_LOCALE[DEFAULT_LANGUAGE];
}
